import DebugModel from "../../../app/debug/model/DebugModel";
import LanguageEntry from "./LanguageEntry";

export default class LanguageModel {
    constructor() {
        this._currentLanguageId = "nl";
        this._availableLanguages = [];
    }

    set currentLanguage(id) {
        this._currentLanguageId = id;
    }

    get currentLanguage() {
        if (DebugModel.hasLanguageOverride()) {
            return DebugModel.languageOverride;
        }

        return this._currentLanguageId;
    }

    get availableLanguages() {
        return this._availableLanguages;
    }

    /**
     * 
     * @param {{ languages: Array<{ id: string, label: string }> }} languagesObj 
     */
    setPropertiesFromObject(languagesObj) {
        this._languages = languagesObj.languages.map(l => new LanguageEntry(l.id, l.label));
        this._defaultLanguage = languagesObj.defaultLanguage;
        this._currentLanguageId = this._languages.find(l => l.id === this._defaultLanguage).id;
    }
}